import { useFlyerDownloadModalContext } from 'src/app/pages/starterDashboardV2/shared/components';

import {
	type UseSharingToolsReturn as BaseUseSharingToolsReturn,
	useSharingTools as useBaseSharingTools,
} from './index';

type SharingToolsActions = {
	navigateToAllTools: () => void;
	navigateToGroupRecommendations: () => void;
	navigateToReadyToSharePosts: () => void;
	navigateToShareVisual: () => void;
	openFlyerDownloadModal: () => void;
};

type UseSharingToolsReturn = Omit<BaseUseSharingToolsReturn, 'actions'> & { actions: SharingToolsActions };

export function useSharingTools(): UseSharingToolsReturn {
	const { data, actions } = useBaseSharingTools();
	const { openModal: openFlyerDownloadModal } = useFlyerDownloadModalContext();

	return {
		data: {
			...data,
		},
		actions: {
			...actions,
			openFlyerDownloadModal: () => {
				openFlyerDownloadModal('starter_dashboard_sharing_tools');
			},
		},
	};
}
